module.exports = __webpack_public_path__ + "img/camera-movie-sharp-light.3e959366.svg";